import { render, staticRenderFns } from "./SupplierExportButton.vue?vue&type=template&id=5ae48ad0"
import script from "./SupplierExportButton.vue?vue&type=script&lang=js"
export * from "./SupplierExportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports